var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TimelineContent as ExperimentalTimelineContent, TimelineHeading as ExperimentalTimelineHeading, TimelineItem as ExperimentalTimelineItem, TimelineLine as ExperimentalTimelineLine, } from "@/components/ui/ExperimentalTimeline";
import { TimelineDescription } from "./TimelineDescription";
import { TimelineDot } from "./TimelineDot";
export function TimelineItem(_a) {
    var step = _a.step, externalProcess = _a.externalProcess, index = _a.index, isLastStep = _a.isLastStep;
    return (_jsxs(ExperimentalTimelineItem, { children: [_jsx(ExperimentalTimelineHeading, __assign({ className: "font-semibold" }, { children: step.name })), _jsx(TimelineDot, { data: externalProcess, step: step }), _jsx(ExperimentalTimelineContent, { children: _jsx(TimelineDescription, { data: externalProcess, step: step }) }), !isLastStep(index) && _jsx(ExperimentalTimelineLine, {})] }, index));
}
